import React, { Component } from 'react';
import { View, Text, TouchableOpacity, Vibration, Animated, Easing, TouchableWithoutFeedback } from 'react-native';
import styles from './style';
import { navigate } from '../../../Utils/navigate';
import { inject, observer } from 'mobx-react/native';
import RootStore from '../../../Store/SearchResult';
import OrderList from '../store';
import PPLogUtil from '../../../Utils/PPLogUtil';
import ItemWrapper from '.';
import { observable } from 'mobx';
import f from '@qnpm/react-native-ext-fetch';
import getClientJson from '../../../Utils/getClientJson';
import URLS from '../../../Constant/urls';
import Util from "../../../Utils/util";
const { getBizVersion } = Util;

const ITEM_HEIGHT = 58;

interface Props {
    data: Object,
    index: Number,
    haveCashback: boolean,
    orderlist: OrderList,
    rootStore: RootStore,
}

interface State {
    top: Animated.Value,
    listToShow: Array<ProgressInfo>,
    data: Object,
    refreshFlag: Boolean,
}

interface ProgressInfo {
    changeTime: String,
    redPoint: Boolean,
    module: String,
    moduleName: String,
    url: String,
    desc: String,
    shortChangeTime: String,
    hasShowed?: Boolean,
}

@inject((store:RootStore)=>({
    rootStore: store,
    orderlist: store.orderlist,
    uiState: store.uiState,
    // dataSource: store.orderlist.dataSource
}))
class ServiceProgress extends Component<Props, State> {


    public static getDerivedStateFromProps(nextProps: any, prevState: any) {
        if (nextProps !== prevState) {
            return nextProps;
        }
        return null;
    }

    public constructor(props: Props) {
        super(props);
        const { data = {} } = this.props;
        this.state = {
            top: new Animated.Value(0),
            listToShow: this.getListToShow(),
            data,
            refreshFlag: false,
        };
        this.currentIndex = 0;
        this.updateData(this.props);
    }

    public shouldComponentUpdate(nextProps: any, nextState: any) {
        if (nextProps === this.props && this.state.refreshFlag === nextState.refreshFlag) {
            return false;
        }
        return true;
    }


    public componentDidUpdate(prevProps: Props) {
        if (prevProps === this.props) {
            return;
        }
        this.updateData(this.props);

    }

    public componentWillUnmount() {
        if (this.timer) {
            clearTimeout(this.timer);
        }
    }

    public componentDidMount() {
        setTimeout(()=>{
            this.handleShowLog();
        }, 300)
    }


    public render() {
        const { haveCashback } = this.props;
        const { listToShow } = this.state;
        if (!listToShow || listToShow.length === 0) {
            return null;
        }
        return (
            <View style={[styles.serviceContainer, {
                marginBottom: haveCashback ? 8 : 16
            }]} {...global.orderAccessibilityLabel(global.orderAccessibilityLabelName.CARD_REFUND_PROCESS)}>
                <Animated.View style={{ position: 'absolute', top: this.state.top, height: '100%', width: '100%', }}>
                    {listToShow.map((item, index) => {
                        return this.renderInfoItem(item, index);
                    })}
                </Animated.View>
            </View>
        )
    }

    private renderInfoItem = (info: ProgressInfo, index: Number) => {
        const { moduleName, redPoint, shortChangeTime, desc } = info;
        return (
            <TouchableWithoutFeedback onPress={()=>{this._onItemClick(info, index)}}>
                <View style={styles.serviceContent}>
                    <View style={styles.serviceTitleRow}>

                        <View style={{ flexDirection: 'row', alignItems: 'center', flex: 1,}}>
                            <Text style={styles.serviceTitleText} numberOfLines={1}>
                                {moduleName}
                            </Text>
                            {this.state.refreshFlag?
                                (redPoint && <View style={styles.redPoint} />)
                                :
                                (redPoint && <View style={styles.redPoint} />)
                            }
                        </View>
                        <Text style={styles.serviceDateText} numberOfLines={1}>
                            {shortChangeTime}
                        </Text>
                    </View>
                    <Text style={styles.serviceDescText} numberOfLines={1}>
                        {desc}
                    </Text>
                </View>

            </TouchableWithoutFeedback>
        )
    }


    private updateData = (props: Props) => {
        const { data = {} } = this.props;

        let list = this.getListToShow();
        if (list.length > 1) { // 需要滚动
            this.resetTop(true);
            this.changeNextInfoDelay();
        }

        this.setState({
            listToShow: list,
            data,
        });

        this.handleShowLog();

    }

    private getListToShow = ()=>{
        const { data = {} } = this.props;
        const { extData = {} } = data;
        let { serviceProgress = [] } = extData;

        serviceProgress = serviceProgress.filter((item: ProgressInfo) => {
            return (item.url && item.moduleName && item.desc && item.shortChangeTime);
        })

        let listToShow = serviceProgress;
        if (serviceProgress.length > 1) {
            listToShow = serviceProgress.slice();
            listToShow.push(listToShow[0]);            
        }

        return listToShow;

    }

    private changeNextInfoDelay = (delay: Number =3000) => {
        if (this.timer) {
            clearTimeout(this.timer);
        }
        this.timer = setTimeout(() => {
            //做动画前判断一下,如果列表只有一个,就不再做动画了
            if (this.state.listToShow && this.state.listToShow.length <= 1) {
                return;
            }

            Animated.timing(
                this.state.top,
                {
                    toValue: -58 * (this.currentIndex + 1),
                    duration: 300,
                    easing: Easing.linear,
                    useNativeDriver: false
                }
            ).start(() => {
                this.currentIndex++;
                this.resetTop();
                this.changeNextInfoDelay();
                this.handleShowLog()

            })
    
        }, delay );
    }

    private handleShowLog = ()=>{
                //埋点相关
                const {orderlist, data, index} = this.props;
                let res = orderlist.itemsShowing.find(item=>{
                    return item?.item?.orderNo === data?.orderNo;
                });
                if (!res) return;

                const currentShowItem: ProgressInfo = this.state.listToShow[this.currentIndex];
                if (!currentShowItem) return;

                //找到数据源中的item,进行标记
                let originItem = undefined;
                const originalData = res.item;
                if (originalData?.extData?.serviceProgress && originalData?.extData?.serviceProgress?.length > 0) {
                    let serviceProgress = originalData?.extData?.serviceProgress;
                    originItem = serviceProgress.find((item: ProgressInfo)=>{
                        return item.url === currentShowItem.url && item.moduleName === currentShowItem.moduleName && item.desc === currentShowItem.desc;
                    })
                }
                if (res && currentShowItem && !currentShowItem.hasShowed) {
                    currentShowItem.hasShowed = true;
                    if (originItem) {
                        originItem.hasShowed = true;
                    }
                    const showingItem = this.state.listToShow[this.currentIndex];
                    this.logForProgressItem(true, showingItem.moduleName);
                }        
    }

    private resetTop = (isForce: Boolean) => {
        if (isForce || this.currentIndex >= this.state.listToShow.length - 1) {
            Animated.timing(
                this.state.top,
                {
                    toValue: 0,
                    duration: 0,
                    easing: Easing.linear,
                    useNativeDriver: false
                }
            ).start();
            this.currentIndex = 0;
        }
    }

    private _onItemClick = (itemInfo:ProgressInfo, itemIndex: Number)=>{

        navigate({
            isSchema: true,
            schema: itemInfo?.url,
        });

        this.props.uiState.isBackFromOrderDetail = true;
        // this.clearRedPoint(itemInfo);

        this.logForProgressItem(false, itemInfo.moduleName);

        itemInfo.redPoint = false;
        const {orderlist, data, index} = this.props;
        let res = orderlist.dataSource.find(item=>{
            return item?.orderNo === data?.orderNo;
        });
        if (res) {
            const currentShowItem: ProgressInfo = this.state.listToShow[this.currentIndex];
            // 找到数据源中的item,进行标记
            let originItem;
            const originalData = res.item;
            if (originalData?.extData?.serviceProgress && originalData?.extData?.serviceProgress?.length > 0) {
                let serviceProgress = originalData?.extData?.serviceProgress;
                originItem = serviceProgress.find((item: ProgressInfo)=>{
                    return item.url === currentShowItem.url && item.moduleName === currentShowItem.moduleName && item.desc === currentShowItem.desc;
                })
            }
            if (originItem) {
                // 原始数据标记为已读
                originItem.redPoint = false;
            }    
        }

        this.setState({
            refreshFlag: !this.state.refreshFlag,
        });

    }

    // CARD_ENTRANCE_START####{"ext":{"busniessType":"*","cardPosition":"*"},"isOrdEntr":"0","bizType":"pp","module":"service","qpVer":"*","page":"order_rn_main","position":"*","operType":"show,click","title":"*","operTime":"*"}####CARD_ENTRANCE_END
    private logForProgressItem = (isShow: Boolean, title: String)=>{
        const {data={}, index} = this.props;
        const extObject = {
            businessType: data.businessType,
            cardPosition: String(index),
        };
        PPLogUtil.serviceProgressShowOrClickLog({
            businessType: data.businessType,
            cardPosition: String(index),
            position: String(this.currentIndex),
            operType: isShow? 'show': 'click',
            title,
        });

    }

}

export default ServiceProgress;